module.exports = __webpack_public_path__ + "img/5.978a6c00.png";